import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Divider, Form, Row, Col, Button } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

import * as ProductoService from 'services/producto.service'

const ValidationSchema = Yup.object().shape({
  porcentajeDescuento: Yup.number().min(0).required(),
  precioLista: Yup.number().min(0).required(),
  precioNeto: Yup.number().min(0).required()
})

const EdicionPrecioSection = ({ info, infoCostosProducto }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idProductoPresentacion: info._idProductoPresentacion || '',
      _idListaPrecio: info._idListaPrecio || '',
      _idPrecioxLista: info._idPrecioxLista || '',
      precioLista: info.precioLista || 0,
      porcentajeDescuento: info.porcentajeDescuento || 0,
      precioNeto: info.precioNeto || 0
    }),
    [info]
  )

  const submitHandler = React.useCallback(
    (data, { setSubmitting }) => {
      ProductoService.actualizarPresentacionPrecioxData(data)
        .then(() => {
          __zariContext.toast('success', 'El registro se ha actualizado.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <>
      <Divider title={`${info.nombreLista} - ${info.nombre}`} noMargin />
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values, handleChange }) => (
          <Form>
            <Row className='mb-4'>
              <Col md={2}>
                <FormGroups.PrecioListaFormGroup
                  fIsSubmitting={isSubmitting}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  iError={errors.precioLista}
                  iTouched={touched.precioLista}
                />
              </Col>
              <Col md={2}>
                <FormGroups.PorcentajeDescuentoFormGroup
                  fIsSubmitting={isSubmitting}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  iError={errors.porcentajeDescuento}
                  iTouched={touched.porcentajeDescuento}
                />
              </Col>
              <Col md={2}>
                <FormGroups.PrecioNetoFormGroup />
              </Col>
              <Col md={2}>
                <FormGroups.MargenUtilidadReposicionFormGroup
                  infoCostosProducto={infoCostosProducto}
                  vPrecioNeto={values.precioNeto}
                />
              </Col>
              <Col md={2}>
                <FormGroups.MargenUtilidadPromedioFormGroup
                  infoCostosProducto={infoCostosProducto}
                  vPrecioNeto={values.precioNeto}
                />
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='&nbsp;' xs={12} />
                  <Col xs={12}>
                    <Button onClick={handleSubmit} disabled={isSubmitting} block>
                      Guardar
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(EdicionPrecioSection)
